export function generateArticleSchema (article, path) {
  return {
    '@type': 'Article',
    headline: article.title,
    datePublished: article.datePublished,
    dateModified: article.dateModified,
    author: {
      '@type': 'Person',
      '@id': `https://querobolsa.com.br${path}#author`,
    },
    publisher: {
      '@type': 'Organization',
      '@id': `https://querobolsa.com.br${path}#organization`,
    },
  }
}
